import { Link, NavLink, useLocation } from "react-router-dom";
import { BuildHofLogoIcon } from "@/components/project/Primitives";
import "@/styles/marketing.css";

export function BuildHofMark({ light = false, size = 26 }) {
  return <BuildHofLogoIcon light={light} size={size} />;
}

const navLinks = [
  { to: "/how-it-works", label: "How it works" },
  { to: "/pricing", label: "Pricing" },
  { to: "/about", label: "About" },
  { to: "/#faq", label: "FAQ", hash: "faq" },
  { to: "/contact", label: "Contact" },
];

export function MarketingLayout({ children, activePath }) {
  const location = useLocation();
  const current = activePath || location.pathname;

  return (
    <div className="bh-marketing" data-testid="marketing-site">
      <header className="nav" data-testid="marketing-topbar">
        <div className="nav-inner">
          <Link to="/" className="brand" data-testid="marketing-brand-link">
            <BuildHofMark />
            <span>BuildHof</span>
          </Link>
          <nav className="links" data-testid="marketing-nav-links">
            {navLinks.map((item) => {
              if (item.hash) {
                return (
                  <Link
                    key={item.label}
                    to={item.to}
                    className={current === "/" && location.hash === `#${item.hash}` ? "active" : undefined}
                    data-testid={`marketing-nav-${item.label.toLowerCase().replaceAll(" ", "-")}-link`}
                  >
                    {item.label}
                  </Link>
                );
              }
              return (
                <NavLink
                  key={item.label}
                  to={item.to}
                  className={({ isActive }) => (isActive ? "active" : undefined)}
                  data-testid={`marketing-nav-${item.label.toLowerCase().replaceAll(" ", "-")}-link`}
                >
                  {item.label}
                </NavLink>
              );
            })}
          </nav>
          <div className="nav-right">
            <span className="lang" aria-label="Language">EN</span>
            <Link className="login-link" to="/login" data-testid="marketing-login-link">Log in</Link>
            <Link className="btn btn-dark btn-sm nav-cta" to="/signup" data-testid="marketing-signup-button">
              <span className="nav-cta-full">Start onboarding</span>
              <span className="nav-cta-short">Start</span>
            </Link>
          </div>
        </div>
      </header>

      {children}

      <footer data-testid="marketing-footer">
        <div className="wrap">
          <div className="footer-grid">
            <div>
              <div className="footer-brand">
                <BuildHofMark light size={24} />
                <span>BuildHof</span>
              </div>
              <p className="blurb">
                A warm, simple storefront and ordering system for restaurants, bakeries, florists, and neighborhood shops across Europe. Part of the Build Up Rise Up family.
              </p>
            </div>
            <div>
              <h4>Product</h4>
              <ul>
                <li><Link to="/how-it-works">How it works</Link></li>
                <li><Link to="/pricing">Pricing</Link></li>
                <li><Link to="/#verticals">Who it&apos;s for</Link></li>
                <li><Link to="/#faq">FAQ</Link></li>
              </ul>
            </div>
            <div>
              <h4>Company</h4>
              <ul>
                <li><Link to="/about">About</Link></li>
                <li><Link to="/contact">Contact</Link></li>
                <li><a href="mailto:hello@buildhof.com">Careers</a></li>
              </ul>
            </div>
            <div>
              <h4>Legal</h4>
              <ul>
                <li><Link to="/impressum">Impressum</Link></li>
                <li><Link to="/privacy">Privacy policy</Link></li>
                <li><Link to="/terms">Terms of service</Link></li>
                <li><Link to="/cookies">Cookie policy</Link></li>
                <li><Link to="/refund">Refund policy</Link></li>
                <li><Link to="/dpa">Data Processing Addendum</Link></li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <span>© 2026 Build Up Rise Up UG (haftungsbeschränkt). All rights reserved.</span>
            <span>Munich, Germany</span>
          </div>
        </div>
      </footer>
    </div>
  );
}

export function MarketingCta({ title, body, to = "/signup", button = "Start onboarding →" }) {
  return (
    <section className="cta-band" data-testid="marketing-cta-band">
      <div className="wrap">
        <h2>{title}</h2>
        <p>{body}</p>
        <Link to={to} className="btn btn-primary" data-testid="marketing-cta-button">{button}</Link>
      </div>
    </section>
  );
}
